import { readHandoff } from '../domain/webLogin';

/**
 * The browser keeps its token for a year (#4218: as long as the token itself lives), unlike the mini app, which
 * signs in on every launch and holds the token in memory only. Storage failures read as "signed out".
 */

const TOKEN_KEY = 'pass24.webToken';
const STATE_KEY = 'pass24.webState';

function get(win: Window, key: string): string | null {
  try {
    return win.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function set(win: Window, key: string, value: string | null) {
  try {
    if (value === null) win.localStorage.removeItem(key);
    else win.localStorage.setItem(key, value);
  } catch {
    // Private mode or blocked storage: the resident signs in again next time.
  }
}

export const loadWebToken = (win: Window) => get(win, TOKEN_KEY);
export const saveWebToken = (win: Window, token: string) => set(win, TOKEN_KEY, token);
export const clearWebToken = (win: Window) => set(win, TOKEN_KEY, null);

/** Saved when the resident presses «Войти через Telegram»; the answer must bring it back. */
export const rememberWebState = (win: Window, state: string) => set(win, STATE_KEY, state);

/**
 * Called before the first render: takes the token from `#webToken=…&state=…` and erases the fragment from the
 * address at once, so it stays neither in history nor on screen. A token is trusted only with the state this
 * browser saved; otherwise the resident confirms the account first (a link could carry someone else's token).
 */
export function consumeHandoff(win: Window): { token: string; trusted: boolean } | null {
  const handoff = readHandoff(win.location.hash);
  if (!handoff) return null;
  win.history.replaceState(win.history.state, '', win.location.pathname + win.location.search);
  const expected = get(win, STATE_KEY);
  set(win, STATE_KEY, null);
  return { token: handoff.token, trusted: expected !== null && handoff.state === expected };
}
